import { action, observable } from 'mobx';
import stores from '../../../models/Stores';
import { UserIdentity } from 'cd-eft/security/UserIdentity';

export class SideNavVM {
  history: any;
  location: any;
  constructor(history, location) {
    this.history = history;
    this.location = location;
  }

  // private eftAuthApi = eftauth.default;

  @observable sidebarActive = true;
  @observable glossaryHelpClicked = false;

  @action.bound toggleSideNav(e: any) {
    e.preventDefault();
    this.sidebarActive = !this.sidebarActive;
  }

  @action.bound toggleGlossaryHelpBack() {
    if (this.glossaryHelpClicked) {
      this.history.goBack();
    }
    else {
      this.history.push('/');
    }
    this.glossaryHelpClicked = false;
  }
  @action.bound toggleGlossaryHelpIcon() {
    this.glossaryHelpClicked = true
  }

  @action.bound async onLogout() {
    // Reset all stores
    stores.AppStore.designStore.reset();
    stores.AppStore.waterwayDesignStore.reset();
    stores.AppStore.designStore.projectsStore.reset();
    stores.AppStore.efh2Store.reset();
    stores.AppStore.efh2Store.projectsStore.reset();
    stores.AppStore.userProfileStore.reset();
    stores.AppStore.projectsLibraryStore.reset();
    stores.AppStore.surveyEngineeringStore.reset();
    stores.AppStore.alignmentDesignStore.reset();
    stores.AppStore.pitDesignStore.reset();
    stores.AppStore.padDesignStore.reset();
    stores.AppStore.landLevelingDesignStore.reset();

    this.history.push('/login');
    // only continue if navigation is not blocked
    if (!window.location.href.includes('/login')) {
      return;
    }
    stores.AppStore.userProfileStore.authError = false;

    // const localStorageUsername: any = localStorage.getItem('username');
    // const invalidateParams: eftauth.IInvalidateTokenRequestParams = { username: localStorageUsername };

    try {
      // const data = await this.eftAuthApi.invalidateToken(invalidateParams);
      // console.log('invalidationStatus: ' + String(data.invalidationStatus));
      await UserIdentity.logout();

      // No check for if logout fails/succeeds to allow logout in any case. - Jared
      // Clear out localStorage of any key/value pairs.
      localStorage.clear();
      // Reset sidebar to open on logout if it is closed.
      if (!this.sidebarActive) {
        this.sidebarActive = !this.sidebarActive;
      }
      // Set userAvailable to false
      stores.AppStore.userProfileStore.userAvailable = false;
    } catch (err) {
      console.error('invalidateToken Error:', err);
      stores.AppStore.userProfileStore.userAvailable = false;
      localStorage.clear();
    }
  }
}
